import { render, staticRenderFns } from "./topList.vue?vue&type=template&id=3f8fc38e&scoped=true&"
import script from "./topList.vue?vue&type=script&lang=js&"
export * from "./topList.vue?vue&type=script&lang=js&"
import style0 from "./topList.vue?vue&type=style&index=0&id=3f8fc38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8fc38e",
  null
  
)

export default component.exports